import { render, staticRenderFns } from "./TabelaResultadosOrgaosUsuario.vue?vue&type=template&id=b3437b64&scoped=true&"
import script from "./TabelaResultadosOrgaosUsuario.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosOrgaosUsuario.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosOrgaosUsuario.vue?vue&type=style&index=0&id=b3437b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3437b64",
  null
  
)

export default component.exports